import { Mail, Instagram } from 'lucide-react'

const contactInfo = [
  {
    Icon: Mail,
    text: 'support@pelajari.ai',
    href: 'mailto:support@pelajari.ai',
  },
  {
    Icon: Instagram,
    text: 'pelajari.ai',
    href: 'https://instagram.com/pelajari.ai',
  },
]

export function LandingFooter() {
  return (
    <footer className="bg-[#f2fbfa] border-t border-[#d5f2ef]">
      <div className="flex flex-col gap-8 px-6 py-12 md:flex-row md:items-start md:justify-between md:px-10 lg:px-[120px] lg:py-[82px]">
        {/* Left Content */}
        <div className="flex flex-col gap-4 max-w-[552px] text-center md:text-left">
          <h2 className="text-[30px] font-semibold leading-[38px] tracking-[-0.5px] text-[#27777a] sm:text-[32px] sm:leading-[42px] lg:text-[36px] lg:leading-[45px] lg:tracking-[-0.75px]">
            Simple. Fast. and Bloom.
          </h2>
          <p className="text-base text-[#1a2727]">
            © 2026 Pelajari by Bloom.AI. All Rights Reserved.
          </p>
        </div>

        {/* Right Content - Contact Info */}
        <div className="flex flex-col gap-4 text-center md:text-left">
          {contactInfo.map((item) => (
            <a
              key={item.text}
              href={item.href}
              target={item.href.startsWith('http') ? '_blank' : undefined}
              rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="flex items-center gap-3 text-[#1a2727] hover:text-[#359d9e] transition-colors justify-center md:justify-start"
            >
              <item.Icon className="w-6 h-6 text-[#359d9e]" />
              <span className="text-base">{item.text}</span>
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
